import { schema } from 'normalizr'
import { Record } from 'immutable'

const _schema = new schema.Entity(
  'overrides',
  {},
  {
    idAttribute: (override) => `${override.event_id}-${override.date}`,
    processStrategy: (entity) => {
      // Backend sends always booking_deadline and cancellation_deadline, so we duplicate the value
      //     - as a host, correctly compare with defaults values as in the calendar
      //     - as a guest, simply getting the value without issues during booking, summary, etc.
      const isPrivate = entity.privatized_at || entity.privatized_by
      return {
        ...entity,
        id: entity._id,
        pe_booking_deadline: isPrivate ? entity.booking_deadline : undefined,
        pe_cancellation_deadline: isPrivate ? entity.cancellation_deadline : undefined,
      }
    },
  },
)
const _Record = Record({
  begins_at: undefined,
  booking_deadline: undefined,
  cancellation_deadline: undefined,
  date: undefined,
  ends_at: undefined,
  event_id: undefined,
  instant_booking: undefined,
  max_seats: undefined,
  min_seats: undefined,
  pe_booking_deadline: undefined,
  pe_cancellation_deadline: undefined,
  price: undefined,
  privatized_at: undefined,
})

export const overrides = {
  schema: _schema,
  Record: _Record,
}

export const emptyOverride = new _Record()
